import { EventName, EVENT_MAPPING } from '@/types/events';

export function normalizeEvent(eventName: EventName): { ga4: string; fb: string } {
  const mapping = EVENT_MAPPING[eventName];
  if (!mapping) {
    // Default normalization for unknown events
    return {
      ga4: eventName.toLowerCase(),
      fb: eventName
    };
  }
  return mapping;
}
